/**
 * Content Loader
 * 'Bar type' Loader which can wrap components which arent ready yet
 */
import React from 'react';

import { LoadingContainer } from './ContentLoader.style';
import LoadingLine from './LoadingLine';

const ContentLoader: React.FC<{
  backgroundColor?: string;
  children: React.ReactNode;
  colour?: string;
  loading: boolean;
  lineCount?: number;
  style?: React.CSSProperties;
}> = ({
  backgroundColor,
  children = null,
  colour,
  loading = false,
  lineCount = 3,
  style,
}) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!loading) return <>{children}</>;

  return (
    <LoadingContainer style={style}>
      {Array.from(Array(lineCount), (_x, index) => (
        <LoadingLine
          backgroundColor={backgroundColor}
          colour={colour}
          key={`loading-line-${index}`}
          opacity={1.0 - index * (1.0 / lineCount)}
          width={`${100 - index * (20 / lineCount)}%`}
        />
      ))}
    </LoadingContainer>
  );
};

export default ContentLoader;
